import { render, staticRenderFns } from "./InputDataRow.vue?vue&type=template&id=452f19fc&scoped=true&"
import script from "./InputDataRow.vue?vue&type=script&lang=js&"
export * from "./InputDataRow.vue?vue&type=script&lang=js&"
import style0 from "./InputDataRow.vue?vue&type=style&index=0&id=452f19fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f19fc",
  null
  
)

export default component.exports